var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"right"}},[_c('v-btn',{staticClass:"mr-2",attrs:{"loading":_vm.loading,"disabled":!_vm.valid},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("Submit")]),_c('back-button',{attrs:{"title":"Cancel"},on:{"click":function($event){return _vm.$emit('cancel')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }